<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <g>
      <rect class="filled" x="8.809" y="12.418" width="46.383" height="7.77" rx="2.22" fill="#304266"/>
      <rect class="filled" x="8.809" y="28.115" width="46.383" height="7.77" rx="2.22" fill="#304266"/>
      <rect class="filled" x="8.809" y="43.812" width="46.383" height="7.77" rx="2.22" fill="#304266"/>
    </g>
    <rect width="64" height="64" fill="none"/>
  </g>
</svg>
